<template>
  <div class="episode-tracklist">
    <h4 class="episode-tracklist__tracklist-heading">
      {{ trackListHeading }}
    </h4>
    <ul class="episode-tracklist__tracklist-list">
      <li
        v-for="track in formattedTracklist"
        :key="track.id"
        class="episode-tracklist__tracklist-list__item"
      >
        <div class="episode-tracklist__tracklist-list__artist">
          {{ track.artist }}
        </div>
        <div class="episode-tracklist__tracklist-list__track">
          {{ track.track }}
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'EpisodeTracklistSection',
  props: {
    trackList: {
      type: String,
      required: true
    }
  },

  computed: {
    trackListHeading() {
      return this.formattedTracklist.length > 0
        ? 'Tracklist'
        : 'No tracklist provided...';
    },

    formattedTracklist() {
      const newFormattedTracklist = [];
      if (this.trackList != null) {
        const splitted = this.trackList.split('|');
        splitted.forEach(element => {
          // const removedWhiteSpace = element.replace(/\s/g, '');
          const trimmed = element.trim().replace(/(\r\n|\n|\r)/gm, '');
          const slpitArtistTrack = trimmed.split(':');
          if (slpitArtistTrack.length > 1) {
            newFormattedTracklist.push({
              artist: slpitArtistTrack[0],
              track: slpitArtistTrack[1]
            });
          }
        });
        return newFormattedTracklist;
      }
      return null;
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_episode-tracklist.scss';
</style>
